export default __webpack_public_path__ + "static/assets/med_gel_solid_01_f_mask.2f539fc2.png";